import tuner from '../tuner';
import baseState from './baseState';

const state = {
  name: 'loaded',
  play: function () {
    // this is called via the tuner after a successful load
    const context = {
      shouldLogStatus: true,
    };
    tuner.changeState(tuner.states.connecting, context);
  },
  playBoostExperience: function () {
    tuner.changeState(tuner.states.connecting, {
      shouldLogStatus: true,
      playBoostExperience: true,
    });
  },
};

export default {
  ...baseState,
  ...state,
};
